import {scroll} from 'motion';

/** Move hero artwork as its header crosses the top of the viewport. */
export function startHeroScroll({target, items, endViewport = 0}) {
    const transform = ({x, unit = 'px'}, progress) => `translate3d(${x * progress}${unit}, 0, 0)`;
    if (window.ViewTimeline && CSS.supports('animation-range-end', 'exit-crossing calc(100% - 1px)')) {
        const timeline = new window.ViewTimeline({subject: target, axis: 'y', inset: '0px'});
        // exit-crossing retains the same endpoints even when the hero is taller
        // than the viewport. Match Motion's viewport measurement for the inset.
        const rangeEnd = () => `exit-crossing calc(100% - ${document.documentElement.clientHeight * endViewport}px)`;
        const animations = items.map((item) => item.element.animate({
            transform: [transform(item, 0), transform(item, 1)],
        }, {
            timeline,
            rangeStart: 'exit-crossing 0%',
            rangeEnd: rangeEnd(),
            fill: 'both',
            easing: 'linear',
        }));
        const onResize = () => {
            const end = rangeEnd();
            animations.forEach((animation) => {
                animation.rangeEnd = end;
            });
        };
        if (endViewport) window.addEventListener('resize', onResize, {passive: true});
        return () => {
            window.removeEventListener('resize', onResize);
            animations.forEach((animation) => animation.cancel());
        };
    }

    // One callback for all shapes; Motion already schedules this with the frame.
    let previousProgress;
    const stop = scroll((progress) => {
        if (progress === previousProgress) return;
        previousProgress = progress;
        items.forEach((item) => {
            item.element.style.transform = transform(item, progress);
        });
    }, {target, offset: [[0, 0], [1, endViewport]]});
    return () => {
        stop();
        items.forEach(({element}) => {
            element.style.transform = '';
        });
    };
}
